import Coupon from '../service/coupon'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getcoupons(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Coupon.getcoupons(payload), {
        type: 'list',
        success,
        fail
      })
    },
    addcoupon(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Coupon.addcoupon(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getcouponnumbers(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Coupon.getcouponnumbers(payload), {
        type: 'list',
        success,
        fail
      })
    },
    invalidcouponnumber(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Coupon.invalidcouponnumber(payload), {
        type: 'action',
        success,
        fail
      })
    },
    enablecoupon(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Coupon.enablecoupon(payload), {
        type: 'action',
        success,
        fail
      })
    },
    disenablecoupon(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Coupon.disenablecoupon(payload), {
        type: 'action',
        success,
        fail
      })
    },
    increasecouponcount(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Coupon.increasecouponcount(payload), {
        type: 'action',
        success,
        fail
      })
    },

    getscancodegifts(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Coupon.getscancodegifts(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getscancodegift(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Coupon.getscancodegift(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getscancodegiftrecords(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Coupon.getscancodegiftrecords(payload), {
        type: 'list',
        success,
        fail
      })
    },
    addscancodegift(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Coupon.addscancodegift(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatescancodegift(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Coupon.updatescancodegift(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
